const PAGES_PREFIX = '@SEARCH';

export const FETCH = `${PAGES_PREFIX}/FETCH`;
export const RESET_QUERY = `${PAGES_PREFIX}/RESET_QUERY`;
export const FETCH_SUCCESS = `${PAGES_PREFIX}/FETCH_SUCCESS`;
export const FETCH_ERROR = `${PAGES_PREFIX}/FETCH_ERROR`;
